import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import Label from '@/components/form/Label/Label';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { EcografiaPdf } from '../pdf/EcografiaPdf';

const DatingHistoryView = props => {
  const { reportData, activeTab, setActiveTab, patientData } = props;

  const [openModal, setOpenModal] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [activeFileIndex, setActiveFileIndex] = useState(0);

  const handleOpenModal = url => {
    setFileUrl(url);
    setActiveFileIndex(0);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setFileUrl(null);
    setOpenModal(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const items = reportData?.radiografia?.data || [];

  const hasItems = items.length > 0;

  const hasRadiografias =
    reportData?.radiografia?.data && reportData.radiografia.data.length > 0;

  const hasEcografias =
    reportData?.radiografia?.data && reportData.radiografia.data.length > 0;

  const radiografias = reportData?.radiografia?.data || [];

  const ecografias = reportData?.radiografia?.data || [];
  const isPdf = url => {
    const clean = url.split('?')[0].toLowerCase();
    return clean.endsWith('.pdf');
  };

  const splitFiles = value => {
    if (!value) return [];
    return value
      .split('||')
      .map(v => v.trim())
      .filter(Boolean);
  };

  const getFileType = url => {
    const clean = url.split('?')[0].toLowerCase();
    if (
      clean.endsWith('.jpg') ||
      clean.endsWith('.jpeg') ||
      clean.endsWith('.png')
    )
      return 'image';
    if (clean.endsWith('.pdf')) return 'pdf';
    return 'other';
  };

  const groupFilesByType = value => {
    const files = splitFiles(value);
    return {
      images: files.filter(f => getFileType(f) === 'image'),
      pdfs: files.filter(f => getFileType(f) === 'pdf'),
      others: files.filter(f => getFileType(f) === 'other'),
    };
  };

  const getModalFiles = value => {
    if (!value) return [];
    return value
      .split('||')
      .map(v => v.trim())
      .filter(Boolean);
  };

  const isPreviewable = url => {
    const clean = url.split('?')[0].toLowerCase();
    return (
      clean.endsWith('.jpg') ||
      clean.endsWith('.jpeg') ||
      clean.endsWith('.png') ||
      clean.endsWith('.pdf')
    );
  };

  const InfoBox = ({ hasData, yesText, noText }) => (
    <FlexContainer
      className="flex-column width100 margt40"
      style={{ alignItems: 'center', textAlign: 'center' }}
    >
      <i
        className="fas fa-exclamation-circle"
        style={{
          fontSize: 80,
          color: '#023B7A',
          marginBottom: 20,
        }}
      />
      <Label className="text-24" style={{ color: '#023B7A', maxWidth: 400 }}>
        <strong>{hasData ? yesText : noText}</strong>
      </Label>
    </FlexContainer>
  );

  return (
    <>
      <div
        className="App bgGradientBlueReverse padt120 m-padtb80"
        style={{
          minHeight: '100vh',
          backgroundSize: '500px',
          backgroundRepeat: 'repeat',
          backgroundPosition: 'top left',
        }}
      >
        <HelmetComponent title="Historial de Citas" />

        <FlexContainer
          className="flex-column width100 padtb40 padlr40 m-padlr10 align-center bgWhite borderrad20 m-format90 m-margb60"
          style={{ maxWidth: 1100, margin: '0 auto' }}
        >
          <Label className="text-32 fontBold" style={{ color: '#023B7A' }}>
            <strong>Mis Resultados</strong>
          </Label>

          <FlexContainer className="flex-row width100 margt10">
            {['radiografía', 'ecografía'].map(tab => (
              <FlexContainer
                key={tab}
                className="flex-1 justify-center pointer padtb6"
                style={{
                  borderBottom:
                    activeTab === tab ? '3px solid #023B7A' : '1px solid #ccc',
                }}
                onClick={() => setActiveTab(tab)}
              >
                <Label
                  className="text-16 fontBold"
                  style={{ color: activeTab === tab ? '#023B7A' : '#888' }}
                >
                  <strong>{tab.charAt(0).toUpperCase() + tab.slice(1)}</strong>
                </Label>
              </FlexContainer>
            ))}
          </FlexContainer>

          {activeTab === 'ecografía' && (
            <>
              {!hasItems ? (
                <InfoBox
                  hasData={false}
                  noText="No tienes ninguna ecografía registrada."
                />
              ) : (
                <FlexContainer
                  className="flex-column width100 margt30"
                  style={{
                    border: '1px solid #ddd',
                    borderRadius: 8,
                    overflow: 'hidden',
                  }}
                >
                  {/* HEADER */}
                  <FlexContainer
                    className="flex-row width100 radiografia-header"
                    style={{
                      background: '#f5f5f5',
                      padding: '12px 16px',
                      fontWeight: 'bold',
                    }}
                  >
                    <FlexContainer style={{ width: 150 }}>
                      <Label className="text-14">FECHA DE ORDEN</Label>
                    </FlexContainer>

                    <FlexContainer className="flex-1">
                      <Label className="text-14">EXAMEN</Label>
                    </FlexContainer>

                    <FlexContainer className="flex-1 m-hide">
                      <Label className="text-14">INFORME</Label>
                    </FlexContainer>
                  </FlexContainer>

                  {items.map(item => {
                    return (
                      <FlexContainer
                        key={`${item.codigo}-${item.paciente?.codigo_de_paciente ?? 'titular'}`}
                        className="flex-row width100 radiografia-row"
                        style={{
                          borderTop: '1px solid #eee',
                          padding: '14px 16px',
                          alignItems: 'center',
                        }}
                      >
                        <FlexContainer
                          style={{ width: 150 }}
                          className="radiografia-field"
                        >
                          <Label className="mobile-label">Fecha</Label>
                          <Label className="text-14">
                            {item.fecha_de_registro || '--'}
                          </Label>
                        </FlexContainer>

                        <FlexContainer className="flex-1 radiografia-field">
                          <Label className="mobile-label">Examen</Label>
                          <Label className="text-14">
                            {item?.orden_y_examene?.[0]?.detalle_de_examen ||
                              '—'}
                          </Label>
                        </FlexContainer>

                        <FlexContainer className="flex-1 radiografia-field m-hide">
                          <Label className="mobile-label">Informe</Label>

                          <PDFDownloadLink
                            document={
                              <EcografiaPdf
                                data={item}
                                patientData={item.paciente || patientData}
                              />
                            }
                            fileName={`Informe_${item.codigo || 'Ecografia'}.pdf`}
                            style={{
                              textDecoration: 'none',
                            }}
                          >
                            {({ loading }) => (
                              <button
                                style={{
                                  border: '1px solid red',
                                  color: 'red',
                                  background: 'transparent',
                                  padding: '4px 10px',
                                  borderRadius: 4,
                                  cursor: loading ? 'wait' : 'pointer',
                                  opacity: loading ? 0.5 : 1,
                                }}
                                disabled={loading}
                              >
                                {loading ? 'GENERANDO...' : 'DESCARGAR INFORME'}
                              </button>
                            )}
                          </PDFDownloadLink>
                        </FlexContainer>
                      </FlexContainer>
                    );
                  })}
                </FlexContainer>
              )}
            </>
          )}

          {activeTab === 'radiografía' && (
            <>
              {!hasItems ? (
                <InfoBox
                  hasData={false}
                  noText="No tienes ninguna radiografía registrada."
                />
              ) : (
                <FlexContainer
                  className="flex-column width100 margt30 radiografia-container"
                  style={{
                    border: '1px solid #ddd',
                    borderRadius: 8,
                    overflow: 'hidden',
                  }}
                >
                  {/* HEADER */}
                  <FlexContainer
                    className="flex-row width100 radiografia-header"
                    style={{
                      background: '#f5f5f5',
                      padding: '12px 16px',
                      fontWeight: 'bold',
                    }}
                  >
                    <FlexContainer style={{ width: 150 }}>
                      <Label className="text-14">FECHA DE ORDEN</Label>
                    </FlexContainer>
                    <FlexContainer className="flex-1">
                      <Label className="text-14">EXAMEN</Label>
                    </FlexContainer>
                    <FlexContainer className={'m-hide'} style={{ width: 140 }}>
                      <Label className="text-14">IMÁGENES</Label>
                    </FlexContainer>
                    <FlexContainer className={'m-hide'} style={{ width: 110 }}>
                      <Label className="text-14">INFORME</Label>
                    </FlexContainer>
                    <FlexContainer className={'m-hide'} style={{ width: 120 }}>
                      <Label className="text-14">DCOM</Label>
                    </FlexContainer>
                  </FlexContainer>

                  {items.map(item => {
                    const { images, pdfs, others } = groupFilesByType(
                      item.imagenes_asociadas,
                    );

                    return (
                      <FlexContainer
                        key={`${item.codigo}-${item.paciente?.codigo_de_paciente ?? 'titular'}`}
                        className="flex-row width100 radiografia-row"
                        style={{
                          borderTop: '1px solid #eee',
                          padding: '14px 16px',
                          alignItems: 'center',
                        }}
                      >
                        <FlexContainer
                          style={{ width: 150 }}
                          className="radiografia-field"
                        >
                          <Label className="mobile-label">Fecha</Label>
                          <Label className="text-14">
                            {item.fecha_de_registro || '--'}
                          </Label>
                        </FlexContainer>

                        <FlexContainer className="flex-1 radiografia-field">
                          <Label className="mobile-label">Examen</Label>
                          <Label className="text-14">
                            {item?.orden_y_examene?.[0]?.detalle_de_examen ||
                              '—'}
                          </Label>
                        </FlexContainer>

                        <FlexContainer
                          className="radiografia-field m-hide"
                          style={{ width: 120 }}
                        >
                          <Label className="mobile-label">Imágenes</Label>

                          {images.length > 0 ? (
                            <button
                              onClick={() =>
                                handleOpenModal(images.join(' || '))
                              }
                              style={{
                                border: '1px solid red',
                                color: 'red',
                                background: 'transparent',
                                padding: '4px 10px',
                                borderRadius: 4,
                                cursor: 'pointer',
                              }}
                            >
                              VER
                            </button>
                          ) : (
                            <Label
                              className="text-20"
                              style={{ color: '#999' }}
                            >
                              <strong>-</strong>
                            </Label>
                          )}
                        </FlexContainer>

                        {/* INFORME */}
                        <FlexContainer
                          className="radiografia-field m-hide"
                          style={{ width: 120 }}
                        >
                          <Label className="mobile-label">Informe</Label>

                          {pdfs.length > 0 ? (
                            <button
                              onClick={() => handleOpenModal(pdfs.join(' || '))}
                              style={{
                                border: '1px solid red',
                                color: 'red',
                                background: 'transparent',
                                padding: '4px 10px',
                                borderRadius: 4,
                                cursor: 'pointer',
                              }}
                            >
                              VER
                            </button>
                          ) : (
                            <Label
                              className="text-20"
                              style={{ color: '#999' }}
                            >
                              <strong>-</strong>
                            </Label>
                          )}
                        </FlexContainer>

                        {/* DCOM */}
                        <FlexContainer
                          className="radiografia-field m-hide"
                          style={{ width: 120 }}
                        >
                          <Label className="mobile-label">DCOM</Label>

                          {others.length > 0 ? (
                            <button
                              onClick={() =>
                                handleOpenModal(others.join(' || '))
                              }
                              style={{
                                border: '1px solid red',
                                color: 'red',
                                background: 'transparent',
                                padding: '4px 10px',
                                borderRadius: 4,
                                cursor: 'pointer',
                              }}
                            >
                              VER
                            </button>
                          ) : (
                            <Label
                              className="text-20"
                              style={{ color: '#999' }}
                            >
                              <strong>-</strong>
                            </Label>
                          )}
                        </FlexContainer>
                      </FlexContainer>
                    );
                  })}
                </FlexContainer>
              )}
            </>
          )}
        </FlexContainer>
      </div>

      {openModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: '80%',
              height: '80%',
              background: '#fff',
              borderRadius: 8,
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <button
              onClick={handleCloseModal}
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                background: 'red',
                color: '#fff',
                border: 'none',
                padding: '6px 10px',
                cursor: 'pointer',
                borderRadius: 4,
                zIndex: 10,
              }}
            >
              X
            </button>

            {(() => {
              const files = getModalFiles(fileUrl);
              const previewableFiles = files.filter(isPreviewable);
              const nonPreviewableFiles = files.filter(f => !isPreviewable(f));

              if (
                previewableFiles.length === 0 &&
                nonPreviewableFiles.length > 0
              ) {
                return (
                  <FlexContainer
                    className="flex-column align-center justify-center width100 height100"
                    style={{ textAlign: 'center' }}
                  >
                    <i
                      className="fas fa-file-archive"
                      style={{ fontSize: 80, color: '#023B7A' }}
                    />
                    <Label className="text-18 fontBold margt10">
                      Este tipo de archivo no se puede previsualizar
                    </Label>

                    {nonPreviewableFiles.map((url, index) => (
                      <a
                        key={index}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          marginTop: 12,
                          color: '#023B7A',
                          fontWeight: 'bold',
                          textDecoration: 'underline',
                        }}
                      >
                        Descargar archivo {index + 1}
                      </a>
                    ))}
                  </FlexContainer>
                );
              }

              return (
                <>
                  {/* LISTA DE ARCHIVOS SI HAY MÁS DE UNO */}
                  {previewableFiles.length > 1 && (
                    <FlexContainer
                      className="gap-8 pad10"
                      style={{
                        background: '#f5f5f5',
                        borderBottom: '1px solid #ddd',
                        flexWrap: 'wrap',
                      }}
                    >
                      {previewableFiles.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setActiveFileIndex(index)}
                          style={{
                            padding: '4px 10px',
                            borderRadius: 4,
                            border:
                              activeFileIndex === index
                                ? '2px solid #023B7A'
                                : '1px solid #ccc',
                            background:
                              activeFileIndex === index ? '#023B7A' : '#fff',
                            color:
                              activeFileIndex === index ? '#fff' : '#023B7A',
                            cursor: 'pointer',
                          }}
                        >
                          Archivo {index + 1}
                        </button>
                      ))}
                    </FlexContainer>
                  )}

                  {/* VISOR */}
                  {isPdf(previewableFiles[activeFileIndex]) ? (
                    <iframe
                      src={previewableFiles[activeFileIndex]}
                      title="Documento"
                      style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                      }}
                    />
                  ) : (
                    <img
                      src={previewableFiles[activeFileIndex]}
                      alt="Imagen"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        background: '#000',
                      }}
                    />
                  )}
                </>
              );
            })()}
          </div>
        </div>
      )}
    </>
  );
};

export default DatingHistoryView;
